/**
 * imgur Uploader — upload images to Imgur
 *
 * Declares a single web-accessible-resource, `options.html`, matched only to
 * `https://api.imgur.com` with no `use_dynamic_url`. It is static and fetchable at a
 * fixed URL, but only from that one origin — from any other page the fetch fails and a
 * negative proves nothing.
 *
 * So this extension is detectable, but only by api.imgur.com. It is the sole exposed
 * resource, so there is no corroborator.
 *
 * Manifest verified against version 2.4.1.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'lcpkicdemehhmkjolekhlglljnkggfcf';

export const imgurUploader: ExtensionDefinition = {
  id: ID,
  name: 'imgur Uploader',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 10_000,
  requiredOrigin: 'https://api.imgur.com',
  notes:
    'One static WAR, options.html, scoped to api.imgur.com — so only that origin can ' +
    'detect it and a negative elsewhere is inconclusive.',
  signals: [
    {
      id: 'war-options-html',
      kind: 'web-accessible-resource',
      description:
        'Fetch options.html — the sole web-accessible resource, static but only ' +
        'exposed to api.imgur.com.',
      weight: 1,
      run: () => probeFetch(ID, 'options.html'),
    },
  ],
};
